/**
 * @auth 赖传峰
 * @date 2024/1/5
 * @desc 活动结束后，302 至活动结束页
 */
import {
  defineNuxtRouteMiddleware,
  navigateTo,
} from '#imports'

export default defineNuxtRouteMiddleware(to => {
  if (to.query.view === '1') return

  return navigateTo({ path: '/activity-end', query: { from: encodeURIComponent(to.path) } })
})
